import type { AxiosResponse } from 'axios';
import type { PaginationParams } from 'types';

// Local Product type definition (previously from @shopify/hydrogen-react)
export type Product = any; // TODO: Define proper product type based on backend API

export enum ActionType {
  GET_SHOP_PRODUCTS = 'GET_SHOP_PRODUCTS',
  SET_SHOP_PRODUCTS = 'SET_SHOP_PRODUCTS',
  GET_SINGLE_SHOP_PRODUCT = 'GET_SINGLE_SHOP_PRODUCT',
  SET_SINGLE_SHOP_PRODUCT = 'SET_SINGLE_SHOP_PRODUCT',
}

export type ShopProducts = {
  products: Product[]
}

export type GetShopProductsPayload = PaginationParams
export type GetShopProductsResponse = AxiosResponse<ShopProducts>

export type GetSingleShopProductByIdPayload = {
  productId?: string
}
export type GetSingleShopProductByIdResponse = AxiosResponse<Product>



